// The solution pages by group, for the header's Solutions menu, the footer
// and Use Cases. Names and paths only, so the header doesn't load page copy.
// docs/refresh/COPY_DECK.md "Solutions › Changes to existing pages".
// Group labels show in the label-uppercase style; the source keeps them in
// sentence case.

export const SOLUTIONS_MENU = 'Solutions';

export const SOLUTION_GROUPS = [
  {
    label: 'By role',
    links: [
      { label: 'Private Equity', to: '/solutions/private-equity' },
      { label: 'Investment Banks', to: '/solutions/investment-banks' },
      { label: 'Corporate Development', to: '/solutions/corporate-development' },
      { label: 'Law Firms', to: '/solutions/law-firms' },
    ],
  },
  {
    label: 'By deal type',
    links: [
      { label: 'Sell-Side M&A', to: '/solutions/sell-side-m-and-a' },
      { label: 'Buy-Side Due Diligence', to: '/solutions/buy-side-due-diligence' },
      { label: 'Capital Raising', to: '/solutions/capital-raising' },
      { label: 'Real Estate', to: '/solutions/real-estate' },
      { label: 'Debt Financing', to: '/solutions/debt-financing' },
    ],
  },
];

export const ALL_USE_CASES = { label: 'All Use Cases', to: '/use-cases' };

// The menu's links count as one section for the header's active underline.
export const isSolutionsPath = (pathname) => pathname === '/use-cases' || pathname.startsWith('/solutions/');
